import { Action, createReducer, on } from '@ngrx/store';
import { GenesysCloudWorkItemIntegrationsState, initialState } from '../genesys-cloud-work-item-integrations.state';
import { toggleIntegrationPanelVisibility, setAllowedIntegrationPanelsForConversation } from '../actions/work-item-integrations.actions';
import { WorkItemIntegration } from '../models/work-item-integrations.model';
import { ConversationBase } from '../../conversations/common/models/conversation-base.model';

const reducer = createReducer(
  initialState(),
  on(toggleIntegrationPanelVisibility, (state, { conversationId, integrationId }) => ({
    ...state,
    openIntegrationPanels: {
      ...state.openIntegrationPanels,
      [conversationId]: addOrRemoveIntegrationFromArray(state.openIntegrationPanels[conversationId.toString()], state.integrations, integrationId)
    }
  })),
  on(setAllowedIntegrationPanelsForConversation, (state, { conversation, integrations }) => ({
    ...state,
    openIntegrationPanels: {
      ...state.openIntegrationPanels,
      [conversation.id]: removeIncompatibleIntegrationsFromArray(integrations, conversation)
    }
  }))
);

export function genesysCloudWorkItemIntegrationsReducer(state: GenesysCloudWorkItemIntegrationsState, action: Action): GenesysCloudWorkItemIntegrationsState {
  return reducer(state, action);
}

function addOrRemoveIntegrationFromArray(
  openIntegrations: WorkItemIntegration[],
  allIntegrations: WorkItemIntegration[],
  toggledIntegrationId: string
): WorkItemIntegration[] {
  const isRemove = openIntegrations?.some(({ id }) => id === toggledIntegrationId);
  return isRemove
    ? openIntegrations.filter(({ id }) => id !== toggledIntegrationId)
    : allIntegrations.filter(integration =>
      openIntegrations?.some(({ id }) => id === integration.id) || integration.id === toggledIntegrationId);
}

function removeIncompatibleIntegrationsFromArray(
  openIntegrations: WorkItemIntegration[],
  conversation: ConversationBase
): WorkItemIntegration[] {
  const compatibleCommunicationTypeIntegrations = openIntegrations?.filter(
    ({ communicationTypes }) => !communicationTypes || communicationTypes.includes(conversation.communicationType));
  const result = compatibleCommunicationTypeIntegrations?.filter(
    ({ conversationFilter }) => !conversationFilter || conversationFilter(conversation));
  return result || [];
}
